import { Route, Routes } from 'react-router-dom'
import { ProtectedShell } from '@/layouts/AppShell'
import { NAV_SECTIONS } from '@/layouts/navSections'
import { PlaceholderScreen } from '@/components/PlaceholderScreen'
import { AccessScreen } from '@/features/access/AccessScreen'
import { ClientDetailScreen } from '@/features/client-overrides/ClientDetailScreen'
import { ClientsListScreen } from '@/features/client-overrides/ClientsListScreen'
import { DashboardScreen } from '@/features/dashboard/DashboardScreen'
import { DiffValidationScreen } from '@/features/diff-validation/DiffValidationScreen'
import { DocumentTypeDetailScreen } from '@/features/document-types/DocumentTypeDetailScreen'
import { DocumentTypesListScreen } from '@/features/document-types/DocumentTypesListScreen'
import { LookupTableScreen } from '@/features/lookup-table/LookupTableScreen'
import { ProductTypeDetailScreen } from '@/features/product-types/ProductTypeDetailScreen'
import { ProductTypesListScreen } from '@/features/product-types/ProductTypesListScreen'
import { ExtractorsScreen } from '@/features/extractors/ExtractorsScreen'
import { GlobalConfigsScreen } from '@/features/global-configs/GlobalConfigsScreen'
import { PromptsScreen } from '@/features/prompts/PromptsScreen'
import { SettingsScreen } from '@/features/settings/SettingsScreen'

const IMPLEMENTED_PATHS = new Set([
  '/product-types',
  '/document-types',
  '/prompts',
  '/extractors',
  '/lookup-table',
  '/client-overrides',
  '/global-configs',
  '/diff-validation',
  '/settings',
])

export default function App() {
  return (
    <Routes>
      <Route path="/access" element={<AccessScreen />} />
      <Route element={<ProtectedShell />}>
        {NAV_SECTIONS.filter((section) => !IMPLEMENTED_PATHS.has(section.path)).map((section) => (
          <Route
            key={section.path}
            path={section.path}
            element={
              section.path === '/' ? (
                <DashboardScreen />
              ) : (
                <PlaceholderScreen title={section.label} />
              )
            }
          />
        ))}
        <Route path="/product-types" element={<ProductTypesListScreen />} />
        <Route path="/product-types/:productId" element={<ProductTypeDetailScreen />} />
        <Route path="/document-types" element={<DocumentTypesListScreen />} />
        <Route path="/document-types/:typeId" element={<DocumentTypeDetailScreen />} />
        <Route path="/prompts" element={<PromptsScreen />} />
        <Route path="/extractors" element={<ExtractorsScreen />} />
        <Route path="/lookup-table" element={<LookupTableScreen />} />
        <Route path="/client-overrides" element={<ClientsListScreen />} />
        <Route path="/client-overrides/:firmId" element={<ClientDetailScreen />} />
        <Route path="/global-configs" element={<GlobalConfigsScreen />} />
        <Route path="/diff-validation" element={<DiffValidationScreen />} />
        <Route path="/settings" element={<SettingsScreen />} />
      </Route>
    </Routes>
  )
}
